module.exports = __webpack_public_path__ + "a890d7a539acd59616f8c655e39b6773.webm";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/god-splitter.webm
// module id = 633
// module chunks = 0